define('models/go_order_license',['require','backbone'],function (require) {
    var Backbone = require("backbone");
  
    return Backbone.Model.extend({
      url: function () {
        // set the endpoint for restful api for articles
        return this.id ? (App.Config.apiBase + "go-orders/" + this.id + "/"): 
          (App.Config.apiBase + "go-orders/");
      },
  
      defaults: function () {
        return {                
            id: null,
            product: '',
            license_email: '',
            has_info: false,
            start_time: '',
            end_time: '',
        };
      },
    });
  });
  
